import { cx } from '@linaria/core';
import 'react';
import { Link } from '@provider/navigation';
import { breakpoints } from '@ui/css';
import { useMatchBreakpoint } from '@utils/react';
import { useCurrentPage } from '../state/hook.current-page.js';
import { iArkStore } from '../state/store.js';
import { list, bullet } from './atom.bullets.style.js';
import { jsx } from 'react/jsx-runtime';

function Bullets(props) {
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const currentPage = useCurrentPage(props.component.data, entryKey);
  if (props.component.data.pages.length <= 1) {
    return null;
  }
  return /*#__PURE__*/jsx("nav", {
    className: props.className,
    children: /*#__PURE__*/jsx("ul", {
      className: list,
      children: props.component.data.pages.map((page, index) => /*#__PURE__*/jsx("li", {
        children: isMobile ?
        /*#__PURE__*/
        // On mobile, bullets should do nothing, see https://dev.azure.com/gyldendaldenmark/GU-Produkter/_workitems/edit/104525
        jsx("span", {
          className: cx(bullet, page.id === currentPage.page?.id && "active")
        }) : /*#__PURE__*/jsx(Link, {
          className: bullet,
          "aria-current": page.id === currentPage.page?.id ? "location" : undefined,
          "aria-label": `Naviger til side ${index + 1}`,
          href: `/${page.id ?? ""}`
        })
      }, page.id))
    })
  });
}

export { Bullets };
//# sourceMappingURL=atom.bullets.js.map
